import React from 'react';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';

export default function Logout() {
	const dispatch = useDispatch()

	dispatch({
		type: 'LOGOUT_USER',
		user: {}
	});

	return <Navigate to="/" />
}